import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import FlexBox from 'components/common/FlexBox';
import CityEditComponent from './CityEditComponent';
import { CollapseCard, Typography } from '@totalsoft/rocket-ui';
import { hierarchyInEditRootIdVar } from 'features/city/variables';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { CityType } from 'features/city/constants';
import { CITY } from 'features/city/queries';
import useQuery from 'hooks/apollo/useQuery';
import { useTranslation } from 'react-i18next';
import CityIcon from '../CityIcon';

const HierarchyHeaderComponent = ({ id }) => {
  const { t } = useTranslation();

  // #region Load data

  const { data: headerData, loading: loadingHeader } = useQuery(CITY, {
    variables: { id },
    skip: !id
  });

  const header = useMemo(() => {
    if (!id)
      return {
        id,
        code: null,
        name: null,
        type: CityType.Country,
        parentCityId: null,
        inactive: false,
        siruta: null
      };
    return headerData?.cityHeader || {};
  }, [headerData, id]);

  // #endregion

  const handleCountrySaved = useCallback(
    country => {
      if (id === country.id) return;
      hierarchyInEditRootIdVar(country.id);
    },
    [id]
  );

  return (
    <CollapseCard
      title={
        <FlexBox gap={0.5} alignItems='center'>
          <CityIcon type={CityType.Country} />
          <Typography variant='subtitle1' fontWeight='bold'>{`${t('City.GeneralData')}${
            header.name ? ` - ${header.name}` : ''
          }`}</Typography>
        </FlexBox>
      }
      actions={<FlexBox gap={0.5} id='hierarchy-header-actions-slot'></FlexBox>}
      defaultExpanded={!id}
    >
      {loadingHeader && <WrappedFakeText lines={5} />}
      {!loadingHeader && (
        <FlexBox column gap={2} alignItems='end'>
          <CityEditComponent data={header} actionsSlotId='hierarchy-header-actions-slot' onCitySaved={handleCountrySaved} />
        </FlexBox>
      )}
    </CollapseCard>
  );
};

HierarchyHeaderComponent.propTypes = {
  id: PropTypes.number
};

export default HierarchyHeaderComponent;
